import { useEffect } from 'react';
import baseURL from '../url';

export default function MetaPixelLoader(){
  useEffect(()=>{
    let mounted = true;
    try{
      const blockedHosts = ['capig.stape.pm'];
      const oldFetch = window.fetch; if (typeof oldFetch === 'function') {
        window.fetch = function(){ const url = String(arguments[0]||''); if (blockedHosts.some(h=>url.includes(h))) { try{ return Promise.resolve(new Response('', { status: 204 })); }catch(_){ return Promise.resolve({ ok:true, status:204 }); } } return oldFetch.apply(this, arguments); };
      }
      const oldBeacon = navigator.sendBeacon; if (typeof oldBeacon === 'function') {
        navigator.sendBeacon = function(url, data){ if (blockedHosts.some(h=>String(url).includes(h))) { return true; } return oldBeacon.call(navigator, url, data); };
      }
      const oldOpen = XMLHttpRequest.prototype.open; if (typeof oldOpen === 'function') {
        XMLHttpRequest.prototype.open = function(method, url){ if (blockedHosts.some(h=>String(url).includes(h))) { this.__blockedCapig = true; } return oldOpen.apply(this, arguments); };
        const oldSend = XMLHttpRequest.prototype.send; XMLHttpRequest.prototype.send = function(body){ if (this.__blockedCapig) { try{ this.abort && this.abort(); }catch(_){ } return; } return oldSend.apply(this, arguments); };
      }
    }catch(_){ }
    const inject = (id)=>{
      if (!mounted || !id) return;
      if (typeof window.fbq === 'function') return; // already loaded
      (function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);
      t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)})(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', id);
      window.fbq('track', 'PageView');
    };
    const load = async ()=>{
      try{
        const r = await fetch(`${baseURL}/pixelPublicGet.php`);
        const d = await r.json();
        if (d && d.ok && d.pixel && d.pixel.enabled && d.pixel.id){
          if (d.pixel.onlyProd && process.env.NODE_ENV !== 'production') { return; }
          inject(d.pixel.id);
        }
      }catch(_){ }
    };
    load();
    return ()=>{ mounted = false; };
  },[]);
  return null;
}
